import React, {useState} from 'react';

import SearchBlockUI from './../../../../stories/components/hotels/HomePage/SearchBlockUI/SearchBlockUI';

import {useNavigateForSearchWidget} from '../../../hooks/useNavigateForSearchWidget';
import useSearchWidget from '../../../hooks/useSearchWidget';
import {eventMiddlewareForFE} from '../../../utils/common-utils';
import {pushga} from 'ga-utils';
import {HomePageGAEvents} from '../../../config/ga-config';

// ! this container is completely similar to SearchWidget except for UI to be rendered
// can be refactored into same, only with children as props
const SearchBlock = () => {
  const {
    checkin,
    checkout,
    roomString,
    destination,
    country,
    partner,
    updateQueryCaller,
    autosuggestHandler,
  } = useSearchWidget();

  const {onSearch} = useNavigateForSearchWidget();

  const [isHomePageAutosuggestEmpty, setIsHomePageAutosuggestEmpty] = useState(false);

  const homePageClicksGAHandler = (
    type:
      | 'locationClicked'
      | 'pax'
      | 'searchTap'
      | 'locationType'
      | 'calendarClicked'
      | 'hotelTopNavigation',
    val = '',
  ) => {
    switch (type) {
      case 'locationClicked':
        pushga({
          eventCategory: HomePageGAEvents.hotelHomePageLocationClicks.category,
          eventAction: HomePageGAEvents.hotelHomePageLocationClicks.action.locationClicked,
        });
        break;

      case 'locationType':
        pushga({
          eventCategory: HomePageGAEvents.hotelHomePageLocationClicks.category,
          eventAction: HomePageGAEvents.hotelHomePageLocationClicks.action.locationType,
          eventLabel: val,
        });
        break;

      case 'pax':
        pushga({
          eventCategory: HomePageGAEvents.hotelHomePageLocationClicks.category,
          eventAction: HomePageGAEvents.hotelHomePageLocationClicks.action.paxClicked,
          eventLabel: val,
        });
        break;

      case 'searchTap':
        pushga({
          eventCategory: HomePageGAEvents.hotelHomePageLocationClicks.category,
          eventAction: HomePageGAEvents.hotelHomePageLocationClicks.action.searchTap,
        });
        break;

      case 'hotelTopNavigation':
        pushga({
          eventCategory: HomePageGAEvents.hotelHomePageClicks.category,
          eventAction: HomePageGAEvents.hotelHomePageClicks.action.hotelTopNavigation,
          eventLabel: val,
        });
        break;

      case 'calendarClicked':
        const arg = {
          eventCategory: HomePageGAEvents.hotelHomePageLocationClicks.category,
          eventAction: HomePageGAEvents.hotelHomePageLocationClicks.action.calendarClicked,
        };
        if (val) {
          arg.eventLabel = val;
        }
        pushga(arg);
        break;

      default:
        break;
    }
  };

  return (
    <SearchBlockUI
      country={country}
      checkin={checkin}
      checkout={checkout}
      roomString={roomString}
      destination={destination}
      partner={partner}
      updateQueryCaller={updateQueryCaller}
      autosuggestHandler={autosuggestHandler}
      onSearchClick={() => {
        if (!destination || !destination.n) {
          setIsHomePageAutosuggestEmpty(true);
          setTimeout(() => {
            setIsHomePageAutosuggestEmpty(false);
          }, 1000);
          return;
        }
        onSearch();
        homePageClicksGAHandler('searchTap');
      }}
      eventMiddlewareForFE={eventMiddlewareForFE}
      homePageClicksGAHandler={homePageClicksGAHandler}
      isHomePageAutosuggestEmpty={isHomePageAutosuggestEmpty}
    />
  );
};

export default SearchBlock;
